<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAnalyticsFormat } from '../analytics/useAnalyticsFormat';

// "Fora da conta, e por quê": o que a página deixa de fora dos números, contado,
// cada um com o motivo. Motivo zerado não aparece; teste incluído na conta não é
// "fora" — a faixa diz que ele entrou. O disparo que ninguém respondeu não mora
// aqui (REPORTS-03): ele é de Campanhas, e a faixa fica com os robôs de fora.
const props = defineProps({
  // A resposta de GET atendimento/fora; null enquanto não chegou.
  report: { type: Object, default: null },
  failed: { type: Boolean, default: false },
});

const { t } = useI18n();
const { number } = useAnalyticsFormat();

const LABELS = {
  test: 'ATENDIMENTO_REPORTS.OUT.TEST',
  other_bots: 'ATENDIMENTO_REPORTS.OUT.OTHER_BOTS',
  before_agent_live: 'ATENDIMENTO_REPORTS.OUT.BEFORE_AGENT_LIVE',
};

const reasons = computed(() =>
  (props.report?.reasons || [])
    .filter(reason => reason.count > 0 && LABELS[reason.key])
    .map(reason => ({
      key: reason.key,
      text: t(
        LABELS[reason.key],
        { count: number(reason.count) },
        reason.count
      ),
    }))
);
</script>

<template>
  <div
    data-test-id="atendimento-fora"
    class="flex flex-wrap gap-x-4 gap-y-1 items-baseline px-3 py-2 min-w-0 text-sm rounded-lg border border-n-weak bg-n-alpha-1"
  >
    <span class="font-medium text-n-slate-12">
      {{ t('ATENDIMENTO_REPORTS.OUT.TITLE') }}
    </span>
    <span v-if="failed" class="text-n-ruby-11">
      {{ t('ATENDIMENTO_REPORTS.FAILED') }}
    </span>
    <template v-else-if="report">
      <span
        v-for="reason in reasons"
        :key="reason.key"
        :data-test-id="`atendimento-fora-${reason.key}`"
        class="text-n-slate-11"
      >
        {{ reason.text }}
      </span>
      <span v-if="report.include_tests" class="text-n-slate-11">
        {{ t('ATENDIMENTO_REPORTS.OUT.TESTS_INCLUDED') }}
      </span>
      <span
        v-if="!reasons.length && !report.include_tests"
        class="text-n-slate-11"
      >
        {{ t('ATENDIMENTO_REPORTS.OUT.NONE') }}
      </span>
    </template>
  </div>
</template>
